import {
    fetchTranscriptFailure,
    fetchTranscriptRequest,
    fetchTranscriptSuccess,
    selectTranscript as selectTranscriptAction,
} from '../actions';
import { ThunkAction } from "../types";
import { fetchTrack } from './trackThunks';


export function selectTranscript(trackID: string): ThunkAction {
    return async (dispatch) => {
        await dispatch(selectTranscriptAction(trackID));
        await dispatch(fetchTranscript(trackID));
        await dispatch(fetchTrack(trackID));
    }
}

export function fetchTranscript(trackID: string): ThunkAction {
    return async (dispatch, getState, {subtitles}) => {
      try {
        const {transcripts} = getState();
        const cached = transcripts.data[trackID];
  
        await dispatch(fetchTranscriptRequest(undefined, {trackID}));
  
        let resp;
        if (cached) {
          resp = cached;
        } else {
          resp = await subtitles.getTranscript(trackID);
        }
  
        await dispatch(fetchTranscriptSuccess(resp, {trackID}));
      } catch (error) {
        await dispatch(fetchTranscriptFailure(error, {trackID}));
        return;
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/thunks/transcriptThunks.ts